export const routes = (prefix) => [
    {
        path: `/${prefix}/consultants`,
        name: `${prefix}.consultants.index`,
        component: () => import('./setup/Index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.consultants.index`,
                PageDescription: "Consultants Listing/Create",
            },
        }
    },
    {
        path: `/${prefix}/consultant-items`,
        name: `${prefix}.consultant-items.index`,
        component: () => import('./items/Index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.consultant-items.index`,
                PageDescription: "Consultant Items Listing/Create",
            },
        }
    }, 
];
